var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "head-container" },
      [
        _vm.crud.props.searchToggle
          ? _c(
              "div",
              [
                _c("label", { staticClass: "el-form-item-label" }, [
                  _vm._v("列表类型1"),
                ]),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "filter-item",
                  staticStyle: { width: "185px" },
                  attrs: { clearable: "", placeholder: "列表类型" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.crud.toQuery($event)
                    },
                  },
                  model: {
                    value: _vm.query.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "type", $$v)
                    },
                    expression: "query.type",
                  },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "el-form-item-label" }, [
                  _vm._v("用户编号"),
                ]),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "filter-item",
                  staticStyle: { width: "185px" },
                  attrs: { clearable: "", placeholder: "用户编号" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.crud.toQuery($event)
                    },
                  },
                  model: {
                    value: _vm.query.userId,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "userId", $$v)
                    },
                    expression: "query.userId",
                  },
                }),
                _vm._v(" "),
                _c("rrOperation", { attrs: { crud: _vm.crud } }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("crudOperation", { attrs: { permission: _vm.permission } }),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              "close-on-click-modal": false,
              "before-close": _vm.crud.cancelCU,
              visible: _vm.crud.status.cu > 0,
              title: _vm.crud.status.title,
              width: "500px",
            },
            on: {
              "update:visible": function ($event) {
                return _vm.$set(_vm.crud.status, "cu > 0", $event)
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  size: "small",
                  "label-width": "80px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "客服" } },
                  [
                    _c("treeselect", {
                      staticStyle: { width: "380px" },
                      attrs: {
                        "load-options": _vm.loadDepts,
                        options: _vm.depts,
                        multiple: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.deptDatas,
                        callback: function ($$v) {
                          _vm.deptDatas = $$v
                        },
                        expression: "deptDatas",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "导购" } },
                  [
                    _c("treeselect", {
                      staticStyle: { width: "380px" },
                      attrs: {
                        "load-options": _vm.loadDepts,
                        options: _vm.depts,
                        multiple: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.deptDatas,
                        callback: function ($$v) {
                          _vm.deptDatas = $$v
                        },
                        expression: "deptDatas",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "设计师" } },
                  [
                    _c("treeselect", {
                      staticStyle: { width: "380px" },
                      attrs: {
                        "load-options": _vm.loadDepts,
                        options: _vm.depts,
                        multiple: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.deptDatas,
                        callback: function ($$v) {
                          _vm.deptDatas = $$v
                        },
                        expression: "deptDatas",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "安装" } },
                  [
                    _c("treeselect", {
                      staticStyle: { width: "380px" },
                      attrs: {
                        "load-options": _vm.loadDepts,
                        options: _vm.depts,
                        multiple: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.deptDatas,
                        callback: function ($$v) {
                          _vm.deptDatas = $$v
                        },
                        expression: "deptDatas",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户编号" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "370px" },
                      model: {
                        value: _vm.form.userId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "userId", $$v)
                        },
                        expression: "form.userId",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  { attrs: { type: "text" }, on: { click: _vm.crud.cancelCU } },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      loading: _vm.crud.status.cu === 2,
                      type: "primary",
                    },
                    on: { click: _vm.crud.submitCU },
                  },
                  [_vm._v("确认")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.crud.loading,
                expression: "crud.loading",
              },
            ],
            ref: "table",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.crud.data, size: "small" },
            on: { "selection-change": _vm.crud.selectionChangeHandler },
          },
          [
            _c("el-table-column", {
              attrs: { type: "selection", width: "55" },
            }),
            _vm._v(" "),
            _c("el-table-column", { attrs: { prop: "id", label: "编号" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "type", label: "列表类型" },
            }),
            _vm._v(" "),
            _c("el-table-column", { attrs: { label: "选中部门" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "userId", label: "用户编号" },
            }),
            _vm._v(" "),
            _vm.checkPer(["admin", "userLists:edit", "userLists:del"])
              ? _c("el-table-column", {
                  attrs: { label: "操作", width: "150px", align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("udOperation", {
                              attrs: {
                                data: scope.row,
                                permission: _vm.permission,
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    398919237
                  ),
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("pagination"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }